// extracted by mini-css-extract-plugin
module.exports = {"router":"View_style_router__1fti3","header":"View_style_header__rlrZS","extra":"View_style_extra__1mdJW","content":"View_style_content__4636c"};